import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { AliasDetails } from '../../alias/alias.model';

interface SessionContextState {
  sessionId: string | null;
  alias: string | null;
  aliasDetails: AliasDetails | null;
  reportId: string | null;
}

const initialState: SessionContextState = {
  sessionId: null,
  alias: null,
  aliasDetails: null,
  reportId: null,
};

export const SessionContextStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(({ aliasDetails }) => ({
    source: computed(() => aliasDetails()?.source),
  })),
  withMethods((store) => ({
    setAlias(alias: string): void {
      patchState(store, { alias });
    },
    setAliasDetails(aliasDetails: AliasDetails): void {
      patchState(store, {
        aliasDetails,
      });
    },
    setSessionId(sessionId: string) {
      patchState(store, { sessionId });
    },
    setReportId(reportId: string) {
      patchState(store, { reportId });
    },
  })),
);
